import { register, CloudObject, defineProperty } from 'olympe';

/**
 * @extends {CloudObject}
 */
export default class MSGraphUser extends CloudObject {

    /**
     * Creates an instance of MSGraphUser.
     *
     * @param {!Transaction} transaction
     * @return {!string} the tag of the created instance
     */
    static create(transaction) {
        return transaction.create(MSGraphUser);
    }
    
    /**
     * @return {string}
     */
    getDisplayName() {
        return this.get(MSGraphUser.displayNameProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeDisplayName($) {
        return this.observe($, MSGraphUser.displayNameProp);
    }

    /**
     * @return {string}
     */
    getGivenName() {
        return this.get(MSGraphUser.givenNameProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeGivenName($) {
        return this.observe($, MSGraphUser.givenNameProp);
    }

    /**
     * @return {string}
     */
    getJobTitle() {
        return this.get(MSGraphUser.jobTitleProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeJobTitle($) {
        return this.observe($, MSGraphUser.jobTitleProp);
    }

    /**
     * @return {string}
     */
    getMail() {
        return this.get(MSGraphUser.mailProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeMail($) {
        return this.observe($, MSGraphUser.mailProp);
    }

    /**
     * @return {string}
     */
    getMobilePhone() {
        return this.get(MSGraphUser.mobilePhoneProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeMobilePhone($) {
        return this.observe($, MSGraphUser.mobilePhoneProp);
    }

    /**
     * @return {string}
     */
    getOfficeLocation() {
        return this.get(MSGraphUser.officeLocationProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeOfficeLocation($) {
        return this.observe($, MSGraphUser.officeLocationProp);
    }

    /**
     * @return {string}
     */
    getPreferredLanguage() {
        return this.get(MSGraphUser.preferredLanguageProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observePreferredLanguage($) {
        return this.observe($, MSGraphUser.preferredLanguageProp);
    }

    /**
     * @return {string}
     */
    getSurname() {
        return this.get(MSGraphUser.surnameProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeSurname($) {
        return this.observe($, MSGraphUser.surnameProp);
    }

    /**
     * @return {string}
     */
    getUserPrincipalName() {
        return this.get(MSGraphUser.userPrincipalNameProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeUserPrincipalName($) {
        return this.observe($, MSGraphUser.userPrincipalNameProp);
    }

    /**
     * @return {string}
     */
    getId() {
        return this.get(MSGraphUser.idProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeId($) {
        return this.observe($, MSGraphUser.idProp);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setDisplayName(transaction, instance, value) {
        transaction.update(instance, MSGraphUser.displayNameProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setGivenName(transaction, instance, value) {
        transaction.update(instance, MSGraphUser.givenNameProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setJobTitle(transaction, instance, value) {
        transaction.update(instance, MSGraphUser.jobTitleProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setMail(transaction, instance, value) {
        transaction.update(instance, MSGraphUser.mailProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setMobilePhone(transaction, instance, value) {
        transaction.update(instance, MSGraphUser.mobilePhoneProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setOfficeLocation(transaction, instance, value) {
        transaction.update(instance, MSGraphUser.officeLocationProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setPreferredLanguage(transaction, instance, value) {
        transaction.update(instance, MSGraphUser.preferredLanguageProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setSurname(transaction, instance, value) {
        transaction.update(instance, MSGraphUser.surnameProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setUserPrincipalName(transaction, instance, value) {
        transaction.update(instance, MSGraphUser.userPrincipalNameProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setId(transaction, instance, value) {
        transaction.update(instance, MSGraphUser.idProp, value);
    }

}

// Hardcoded tags
register('018d1c9363a051c9bfab', MSGraphUser);
MSGraphUser.displayNameProp = defineProperty('018d1c9477f98a83fa98');
MSGraphUser.givenNameProp = defineProperty('018d1c948f1243cb1298');
MSGraphUser.jobTitleProp = defineProperty('018d1c94bd498edabdd1');
MSGraphUser.mailProp = defineProperty('018d1c94d9efa6955b7e');
MSGraphUser.mobilePhoneProp = defineProperty('018d1c94f136aa77aacb');
MSGraphUser.officeLocationProp = defineProperty('018d1c9514cb4e95d626');
MSGraphUser.preferredLanguageProp = defineProperty('018d1c952966a07d7f17');
MSGraphUser.surnameProp = defineProperty('018d1c95496c18e5a499');
MSGraphUser.userPrincipalNameProp = defineProperty('018d1c956aedb1d88107');
MSGraphUser.idProp = defineProperty('018d1c9586d060fa2f1a');
